export const getDefaultTimezone = () => {
  return process.env.GATSBY_DEFAULT_TIMEZONE || "Europe/Berlin";
};
